module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/store_images/1@2x_485b078ba554e6db1234aef5bee34d15.png";